module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#trending",
      toString: function () {
        return this.url;
      }
    }